module.exports = __webpack_public_path__ + "img/bornutti22.02f62e0e.jpg";